import React from "react";
import { useNavigate } from 'react-router-dom';


const Tutoriales = () => {

    const tutoriales = [
        {
            titulo: "Ingreso al Sistema",
            descripcion: "Pasos a seguir para ingresar al sistema, restablecer su contraseña, seleccionar la compañía que tiene autorizado e identificar los diferentes menús",
            link: "https://youtu.be/RQ5F24SbPBg",
            icon: "fa-sign-in-alt"
        },
        {
            titulo: "Clientes",
            descripcion: "Mantenimiento de datos de clientes",
            link: "https://youtu.be/4owtcpcqXrk",
            icon: "fa-user-friends"
        },
        {
            titulo: "Productos y Servicios",
            descripcion: "Administración de los datos de productos y servicios",
            link: "https://youtu.be/9u2pcnsXzhc",
            icon: "fa-boxes"
        },
        {
            titulo: "Factura Electrónica",
            descripcion: "Pasos que debe seguir para crear una factura electrónica",
            link: "https://youtu.be/nN_6gk6Zxb4",
            icon: "fa-file-invoice-dollar"
        },
        {
            titulo: "Factura a Crédito",
            descripcion: "Consideraciones que debe tomar al momento de crear una factura a crédito",
            link: "https://youtu.be/M7XY0eUA-H8",
            icon: "fa-credit-card"
        },
        {
            titulo: "Recibo Electrónico de Pago",
            descripcion: "Explicación de como hacer un recibo de pago electrónico a partir de la versión 4.4 de Hacienda",
            link: "https://youtu.be/WIMDvac1tdY",
            icon: "fa-receipt"
        },
        {
            titulo: "Factura Exonerada",
            descripcion: "Indicaciones para hacer una factura exonerada",
            link: "https://youtu.be/doZclAxfnUg",
            icon: "fa-file-invoice"
        },
        {
            titulo: "Tiquete Electrónico",
            descripcion: "Documento que debe hacerse para los clientes que son consumidores finales que no están inscritos en Hacienda o simplemente cuando al cliente no le interesa la factura pero usted debe reportar dicha venta",
            link: "https://youtu.be/4GVAfHgCxV4",
            icon: "fa-ticket-alt"
        },
        {
            titulo: "Notas de Crédito y Notas de Débito",
            descripcion: "Cuando se requiere revertir, corregir o disminuir un monto facturado, se debe generar una Nota de Crédito o Débito en algunos casos",
            link: "https://youtu.be/Bo9Vce8FAKs",
            icon: "fa-file-alt"
        },
        {
            titulo: "Subir Compras",
            descripcion: "Cargar las compras recibidas al sistema para la aceptación ante Hacienda",
            link: "https://youtu.be/U4KiazTcR0o",
            icon: "fa-upload"
        },
        {
            titulo: "Reportes",
            descripcion: "Explicación de como generar e interpretar los reportes de sus movimientos de facturación",
            link: "https://youtu.be/-nJVNPgHFXQ",
            icon: "fa-chart-bar"
        },
        {
            titulo: "Reportar Pago",
            descripcion: "Si tiene el plan mensual, este es el proceso que debe seguir para reportar su pago",
            link: "https://youtu.be/dBVvoVeahAE",
            icon: "fa-money-check-alt"
        },
        {
            titulo: "Activación de Plan",
            descripcion: "Active y reporte el pago cuando adquiera un paquete de documentos",
            link: "https://youtu.be/as7eX6y7Aw4",
            icon: "fa-bolt"
        }
    ];

    const estilos = {
        cardsGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "28px 22px",
            marginTop: "30px",
            marginBottom: "30px"
        },
        card: {
            background: "#f8fafc",
            borderRadius: "14px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
            padding: "22px 18px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            minHeight: "210px",
            justifyContent: "space-between",
            transition: "box-shadow 0.2s, background 0.2s, transform 0.2s",
            cursor: "pointer"
        },
        cardHover: {
            background: "#e6f7ee",
            boxShadow: "0 4px 20px rgba(19,102,51,0.18)",
            transform: "translateY(-4px) scale(1.03)"
        },
        titulo: {
            fontSize: "1.35rem", // aumentado
            fontWeight: "600",
            color: "#136633",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "12px"
        },
        descripcion: {
            fontSize: "1.15rem", // aumentado
            color: "#222",
            marginBottom: "22px"
        },
        boton: {
            background: "#136633",
            color: "#fff",
            border: "none",
            borderRadius: "7px",
            padding: "10px 22px", // aumentado
            fontSize: "1.15rem", // aumentado
            cursor: "pointer",
            fontWeight: "500",
            transition: "background 0.2s",
            textDecoration: "none",
            display: "inline-block"
        },
        tituloModulo: {
            fontSize: "2.5rem", // aumentado
            fontWeight: "700",
            color: "#136633",
            marginBottom: "12px",
            display: "flex",
            alignItems: "center",
            gap: "16px"
        },
        apreciacion: {
            fontSize: "1.25rem", // aumentado
            color: "#444",
            marginBottom: "22px"
        }
    };

    const navigate = useNavigate();

    const Salir = () => {
        navigate("/");
    }
    const handleOnSubmit = async (e) => {

        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };

    const [hovered, setHovered] = React.useState(null);

    return (
        <div className='main-block'>
            <div className="form" onSubmit={handleOnSubmit}>
                <div className='formadoShadow'>
                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}>
                            <span style={estilos.tituloModulo}>
                                <i className="fas fa-chalkboard-teacher"></i> Tutoriales Smart FE
                            </span>
                        </p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome">
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                    <div style={estilos.apreciacion}>
                        Explora nuestros tutoriales para dominar cada módulo del sistema. Aprende de forma visual y sencilla, y resuelve tus dudas rápidamente. ¡Tu experiencia Smart FE será más fácil y eficiente!
                    </div>
                    <div style={estilos.cardsGrid}>
                        {tutoriales.map((card, idx) => (
                            <div
                                key={idx}
                                style={hovered === idx
                                    ? { ...estilos.card, ...estilos.cardHover }
                                    : estilos.card}
                                onMouseEnter={() => setHovered(idx)}
                                onMouseLeave={() => setHovered(null)}
                            >
                                <div style={estilos.titulo}>
                                    <i className={`fas ${card.icon}`}></i> {card.titulo}
                                </div>
                                <div style={estilos.descripcion}>{card.descripcion}</div>
                                <a
                                    href={card.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={estilos.boton}
                                >
                                    Ver tutorial
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
};
export default Tutoriales;